/** @format */

import React, { useState } from "react";
import Modal from "react-responsive-modal";
import { sendModalView } from "../Analytics";

/**
 * @deprecated TODO replace with Chakra-UI Modals
 */
const WithModal = (ComposedComponent) => {
  // noinspection UnnecessaryLocalVariableJS // This needs to be declared as a variable so the useState lint rules know it's a component.
  const WrappedComponent = (props) => {
    const [modalOpen, setModalOpen] = useState(props.startOpen);
    const showModal = () => {
      setModalOpen(true);
    };
    const handleCloseModal = () => {
      setModalOpen(false);
      props.afterClose && props.afterClose();
    };

    const modalWrap = (
      component,
      {
        trackPath = null,
        showCloseIcon = false,
        closeOnOverlayClick = true,
        modalStyles = {},
      } = {},
    ) => {
      return (
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          showCloseIcon={showCloseIcon}
          closeOnOverlayClick={closeOnOverlayClick}
          onEntered={trackPath && (() => sendModalView(trackPath))}
          focusTrapped={
            false /* TODO - react-responsive-modal 4.0 added this, but it makes the document popups short by wrapping content in a bare <div> so our height=100% doesn't work. */
          }
          styles={{
            overlay: {
              backgroundColor: "rgba(79, 79, 79, 0.45)",
            },
            modal: Object.assign(
              {},
              {
                /*position: "absolute",
                                   top: "40px",
                                   left: "20%", // TODO - fiddle with these in different screen/browser sizes
                                   right: "20%",
                                   bottom: "40px",                         padding: "20px"
          */
                border: "1px solid #ccc",
                background: "#fff",
                /*overflow: "auto",
                                   WebkitOverflowScrolling: "touch",*/
                borderRadius:
                  "calc(1em + 20px)" /* border-radius of .propertyHeroPhoto plus this padding so the curves look like they match. */,
                outline: "none",
              },
              modalStyles,
            ),
          }}
        >
          {component}
        </Modal>
      );
    };

    return (
      <ComposedComponent
        {...props}
        showModal={showModal}
        closeModal={handleCloseModal}
        modalContent={modalWrap}
      />
    );
  };
  return WrappedComponent;
};

export default WithModal;
